<template>
  <div id="detection-wrapper">
        <div class="header-common">
            <img src="../assets/images/back.png" alt="" class="icon" @click="goback">
            <span class="title">深度检测</span>
            <span id="skipAll" @click="skipAll">全部跳过</span>
        </div>
        <div class="progress-wrapper"  v-if="questions.length>0" :length= "questions.length">
            <div class="progress-bar-wrapper">
                <div class="progress-bar">
                    <div class="progress" :style="'width:' + (qnum/(questions.length)).toFixed(2)*100 +'%' "></div>
                </div>
                <span class="progress-percent" >{{(qnum/(questions.length)).toFixed(2)*100}}%</span>
            </div>
            <div class="qid">{{qcount+1}}&nbsp;/&nbsp;{{questions.length}}</div>

        </div>

      <div class="question-content"  v-if="questions.length>0">
            <div class="q_topic">
                <span class="q_num">{{qcount+1}}.</span>
                <span class="q_title">{{questions[qcount].title}}</span>
            </div>
            <ul class="question-ul">
                <li v-for="(item,index) in questions[qcount].options" class="option" @click="chooseAnswer(questions[qcount].id,item.id)" :id ="item.id"  :aid="aid" :class="{'q_selected':item.id == aid}" :key="item.id">
                    <span class="option_name">{{alphabet[index]}}</span>
                    <span>{{item.option}}</span>
                </li>
            </ul>
            <div class="q_footer">
                <!-- <span class="skip_one" @click="skipOne" :class="{'disabled':qcount==questions.length-1,'hidden':qcount == questions.length}" >跳过此题</span> -->
                <span class="skip_one" @click="skipOne"  >跳过此题</span>
                
                <span class="submit_test" :class="{'go_submit':answer.length == questions.length}" @click="goSubmit" >提交检测</span>
            </div>
      </div>
     
  </div>
</template>

<script>
import {Indicator } from 'mint-ui';
export default {
    name:"detection",
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            questions:[],
            alphabet:['A','B','C','D','E','F','G','H','I','J','K'],
            qcount:0,//下标
            qnum:0,//回答
            aid:"",//选择的答案
            answer:[],//答案

        }
    },
    methods:{
        goback(){
            let gid = this.$route.params.gid;
            this.$router.replace({name:'purchase_service',params:{gid:gid}});
        },
        chooseAnswer(qid,aid){
            Indicator.open('加载中');
            this.qnum =  this.qnum + 1 > this.questions.length-1?this.questions.length:this.qnum+1;
            this.aid = aid;
            var vm = this;
            let answer_ = {
                'qid':qid,
                'selected':aid,
            }; 
           
            let change = false;
            if(vm.answer.length>0){
                for(let i=0;i<vm.answer.length;i++){
                    if(vm.answer[i].qid == qid){
                        change = true;
                        vm.answer[i] = answer_;
                    }
                }
            }
            if(!change){
                vm.answer.push(answer_);
            }
            sessionStorage.answer = JSON.stringify(vm.answer);
            setTimeout(function(){
                vm.qcount = vm.qcount+1 >= vm.questions.length-1?vm.questions.length-1:vm.qcount + 1;
                Indicator.close();
            },300)

        },
        getQuestions(){
            let gid_ = this.$route.params.gid;
            var vm = this;
            this.$store.dispatch("getGoodsInfo",{gid:gid_,api_version:window.config.api_version}).then((res)=>{
                let data = res.data;
                if(data.code == 0){
                    vm.questions = data.res.data.questions;
                    vm.valid();
                }
            })
        },
        skipOne(){
            
            var vm = this;
            let qid = vm.questions[this.qcount].id;
            let void_answer = {
                'qid':qid,
                'selected':0,
                'answer':'跳过'
            };
            let change = false;
            if(vm.answer.length>0){
                for(let i=0;i<vm.answer.length;i++){
                    if(vm.answer[i].qid == qid){
                        vm.answer[i] = void_answer;
                        vm.aid = 0;
                        change = true;
                    }
                }
            }
            if(!change){
                this.qcount = this.qcount+1 >= this.questions.length-1?this.questions.length-1:this.qcount + 1;
                this.qnum =  this.qnum + 1 > this.questions.length-1?this.questions.length:this.qnum+1;
                vm.answer.push(void_answer);
            }
            sessionStorage.answer = JSON.stringify(vm.answer);
        },
        skipAll(){
            let gid = this.$route.params.gid;
            this.$router.replace({name:'purchase_service',params:{gid:gid}});
        },
        valid(){
            Indicator.open('加载中');
            setTimeout(function(){
                Indicator.close();
            },300)  
            let gid_ = this.$route.params.gid;
            if(!sessionStorage.qtype ||  sessionStorage.qtype != gid_){//从第一题开始
                sessionStorage.qtype = gid_;//题目类型
                sessionStorage.removeItem('answer');
                this.$router.replace({name:'questionnaire',params:{gid:gid_},query:{qid:0}})//qid下标
            }else{
                let qid = this.$route.query.qid;
               
                if(qid!=0&&qid==undefined){
                    this.$router.replace({name:'questionnaire',params:{gid:gid_},query:{qid:0}})
                    sessionStorage.removeItem('answer');
                }else{
                     qid = parseInt(qid);
                    if(sessionStorage.answer){
                        let answer = JSON.parse(sessionStorage.answer);
                        this.answer = answer;
                        if(answer.length == qid || answer.length == qid + 1){
                            this.qcount = qid;
                            this.aid = answer[answer.length - 1].selected;
                        if(answer.length>qid){
                            this.qnum = answer.length;
                        }else{
                            this.qnum = qid+1;
                        }
                        }
                    }else{
                        this.$router.replace({name:'questionnaire',params:{gid:gid_},query:{qid:0}})
                    }
                    
                }
            };
        },
        goSubmit(){
            if(!(this.answer.length == this.questions.length && this.questions.length>0)){
                return
            };
            let vm = this;
            let gid = this.$route.params.gid;
            let access_token =localStorage.access_token;
            let data  = {
                info:{
                    'answers':vm.answer,
                    'cfrom':2,
                    app_id:window.config.appid
                },
            };
            if(access_token){
                data.access_token = access_token;
            }
            if(sessionStorage.ghash){
                data.info.ghash = sessionStorage.ghash;
            }
            this.$store.dispatch("submitQuestionnaire",data).then((res)=>{
                var data = res.data;
                if(data.code == 0){//购买
                    sessionStorage.batch_id = data.res.batch_id;
                    vm.$router.replace({name:'purchase_service',params:{gid:gid}});
                }else if(data.code == 1200 || data.code == 1201){
                    new Promise(vm.refreshToken).then(function(token){
                        let gid_ = vm.$route.params.gid;
                        if(gid_){
                            vm.goSubmit();
                        }
                    })
                }
            })
           
        },
        getUserInfo(){
            let vm = this;
            if(this.validToken()){
                let access_token = localStorage.access_token;
                let info = {
                    'access_token':access_token
                };
                this.$store.dispatch("getUserinfo",info).then((res)=>{
                    Indicator.close();
                    let data = res.data;
                    if(data.code == 1200){
                        new Promise(vm.refreshToken).then(function(token){
                            let gid_ = vm.$route.params.gid;
                            if(gid_){
                                vm.getQuestions();
                            }
                        })
                            
                    }else if (data.code == 1201){
                        vm.$router.pash({name:"login"})
                    }else if(data.code == 0){
                        let gid_ = vm.$route.params.gid;
                        if(gid_){
                            vm.getQuestions();
                        }
                    }
                })
            }
        }
    },
    created(){
        let gid_ = this.$route.params.gid;
        if(gid_){
            // this.getQuestions();
            this.getUserInfo()
        }

    },
    mounted(){
    },
    watch:{
        qcount(){
            this.$router.replace({query:{qid:this.qcount}});
        },
    },
  
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Questionnaire.vue